import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'

interface CmsBlockData {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
}

interface Props {
  id: string
  children: (obj: CmsBlockData) => React.ReactElement | null
  isLazy?: boolean
}

export const CmsBlock = ({
  id,
  children,
  isLazy
}: Props) => {
  const cmsBlockData = useCmsBlock({
    id,
    isLazy
  }) as CmsBlockData

  return (
    <>
      {children({
        ...cmsBlockData
      })}
    </>
  )
}
